module.exports = __webpack_public_path__ + "static/media/IMG_1907.62293f40.JPG";